// Khoá "đã xem tour" của app — TỆP THUẦN, CỐ Ý 0 IMPORT.
//
// 💣 VÌ SAO PHẢI Ở TỆP RIÊNG (09/08/2026 — đo, không đoán): hằng số này trước nằm trong
//    `components/AppTour.tsx`, mà tệp đó `import { Tour } from "@/components/ui"`. Trang Trợ giúp
//    chỉ cần ĐÚNG MỘT CHUỖI để xoá khoá localStorage khi bấm "xem lại tour", nhưng
//    **nhập một hằng số là nhập cả module** ⇒ `/help` kéo theo cả bộ Tour + nội dung 8 bước.
//    Cùng họ với quả mìn `consent.ts` bên nhonho (một hàm thuần kéo theo 97,7 kB bộ mã hoá).
//
// 🧠 Luật: **thứ NHẸ mà nhiều nơi cần thì phải nằm ở tệp 0-import.** Để chung với thứ nặng là
//    biến mọi nơi gọi nó thành một cửa sau dẫn thẳng vào cục nặng, im lặng, không lỗi.
//
// Đổi hậu tố "_vN" khi muốn TẤT CẢ người dùng xem lại tour (vd sau nâng cấp lớn).
export const TOUR_ID = "hidental_tour_v1";
